import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const YT_ID = "JXJ5tziBXxI";
const YT_EMBED_SRC = `https://www.youtube-nocookie.com/embed/${YT_ID}?rel=0&modestbranding=1&iv_load_policy=3`;

const CLUBS = {
  winchester: {
    pageTitle: "Winchester Junior Chess Club",
    fourSessionPassUrl: "https://book.stripe.com/9B67sL3sd9i45cW0dq97G0s",
    novemberPaygUrl: "https://book.stripe.com/fZufZhe6R65ScFoe4g97G0o",
    novemberSessionDays: [5, 12, 19, 26],
    decemberSessionDays: [3, 10, 17],
    decemberPaygUrl: "https://book.stripe.com/fZufZhfaVfGs48SbW897G0p",
    decemberDates: "3, 10 and 17 December 2026",
    schedule: "Thursdays, 18:00–19:00",
    scheduleVenue: "Badger Farm Community Centre",
    paygUrl: "https://book.stripe.com/cNifZh8MxeCo6h08JW97G0m",
    octoberDates: "1, 8 and 22 October 2026",
    breakNote: "No club on Thursday 15 October or Thursday 29 October. October sessions run on 1, 8 and 22 October only.",
    septemberPaygUrl: "https://book.stripe.com/3cIbJ11k5dyk20Kgco97G0i",
    septemberSession: "Thursday 24 September 2026, 18:00–19:00",
    septemberBookingClosesAt: "2026-09-24T18:00:00+01:00",
    venueName: "Badger Farm Community Centre",
    venueLines: ["Badger Farm Road", "Winchester", "SO22 4QB"],
    venueQuery:
      "Badger Farm Community Centre, Badger Farm Road, Winchester SO22 4QB, UK",
    mapTitle: "Map: Badger Farm Community Centre",
    shortLabel: "Winchester",
    intro:
      "A welcoming weekly chess club for children who want to learn well, play regularly and develop confidence over the board.",
  },
  "colden-common": {
    pageTitle: "Colden Common Junior Chess Club",
    fourSessionPassUrl: "https://book.stripe.com/3cIeVde6R51O34O5xK97G0t",
    novemberPaygUrl: "https://buy.stripe.com/3cI5kD7It9i4gVEaS497G0r",
    novemberSessionDays: [6, 13, 20, 27],
    decemberSessionDays: [4, 11, 18],
    decemberPaygUrl: "https://book.stripe.com/9B628r0g18e06h07FS97G0q",
    decemberDates: "4, 11 and 18 December 2026",
    schedule: "Fridays, 18:00–19:00",
    scheduleVenue: "Colden Common Community Centre",
    paygUrl: "https://book.stripe.com/fZudR93sd2TG48S2ly97G0n",
    octoberDates: "2, 9 and 30 October 2026",
    breakNote: "No club on Friday 16 October or Friday 23 October. Sessions resume on Friday 30 October.",
    septemberPaygUrl: "https://book.stripe.com/4gM6oH7It1PCbBkf8k97G0k",
    septemberSession: "Friday 25 September 2026, 18:00–19:00",
    septemberBookingClosesAt: "2026-09-25T18:00:00+01:00",
    venueName: "Colden Common Community Centre",
    venueLines: ["Saint Vigor Way", "Colden Common", "SO21 1UU"],
    venueQuery:
      "Colden Common Community Centre, Saint Vigor Way, Colden Common, SO21 1UU, UK",
    mapTitle: "Map: Colden Common Community Centre",
    shortLabel: "Colden Common",
    intro:
      "A friendly local chess club where children can build strong foundations, enjoy competitive play and improve week by week.",
  },
};

const BENEFITS = [
  "Structured coaching for beginners and improving players",
  "Regular games against children of a similar level",
  "Practical feedback that children can use immediately",
  "A calm, respectful environment that builds confidence",
];


const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

function MonthBookingCalendar({ title, monthIndex, sessionDays, paymentUrl }) {
  const firstWeekday = new Date(Date.UTC(2026, monthIndex, 1)).getUTCDay();
  const mondayOffset = (firstWeekday + 6) % 7;
  const daysInMonth = new Date(Date.UTC(2026, monthIndex + 1, 0)).getUTCDate();
  const calendarDays = Array.from(
    { length: mondayOffset + daysInMonth },
    (_, index) => index < mondayOffset ? null : index - mondayOffset + 1
  );

  return (
    <div style={{
      padding: 22,
      border: "1px solid rgba(216,183,99,0.23)",
      borderRadius: 18,
      background: "rgba(255,255,255,0.035)",
    }}>
      <h3 style={{ margin: "0 0 12px", color: "#fffaf0", fontSize: "1.25rem", fontWeight: 800 }}>
        {title}
      </h3>
      <p style={{ color: "#d8b763", fontWeight: 800, margin: "0 0 16px" }}>
        £10 per child · 18:00–19:00
      </p>
      <div className="club-month-calendar" role="group" aria-label={`Chess sessions – ${title}`}>
        {WEEKDAYS.map((day) => (
          <span key={day} className="club-calendar-weekday">{day}</span>
        ))}
        {calendarDays.map((day, index) => {
          const isSession = day !== null && sessionDays.includes(day);
          return (
            <span
              key={`${title}-${index}`}
              className={`club-calendar-day${isSession ? " is-session" : ""}`}
              aria-label={day === null ? undefined : `${day} ${title}: ${isSession ? "session available" : "no club"}`}
            >
              {day === null ? "" : day}
            </span>
          );
        })}
      </div>
      <p style={{ margin: "16px 0 8px", color: "#fffaf0", fontWeight: 700 }}>
        Club dates: {sessionDays.join(", ")} {monthIndex === 10 ? "November" : "December"}
      </p>
      <p style={{ margin: "0 0 16px", color: "rgba(246,242,232,0.76)", lineHeight: 1.6, fontSize: 14 }}>
        The highlighted dates are club days. Select your chosen date again in the
        secure Stripe form and enter your child's name. A date is booked after payment.
      </p>
      <a href={paymentUrl} target="_blank" rel="noreferrer"
         className="club-booking-link club-booking-primary">
        Book {monthIndex === 10 ? "November" : "December"} session — £10
      </a>
    </div>
  );
}

function ChessClubVenuePage({ clubId = "winchester" }) {
  const club = CLUBS[clubId] || CLUBS.winchester;
  // Keep this week's existing PAYG booking available until the session starts.
  const showSeptemberBooking =
    Date.now() < new Date(club.septemberBookingClosesAt).getTime();

  const mapEmbedUrl =
    "https://www.google.com/maps?q=" +
    encodeURIComponent(club.venueQuery) +
    "&output=embed";

  const placeUrl =
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(club.venueQuery);

  const directionsUrl =
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent(club.venueQuery);

  const page = {
    width: "100%",
    minHeight: "100vh",
    color: "#f6f2e8",
    background:
      "linear-gradient(180deg, rgba(7, 21, 44, 0.98), rgba(5, 14, 31, 0.99))",
  };

  const wrap = {
    maxWidth: 1120,
    margin: "0 auto",
    padding: "clamp(28px, 5vw, 64px) clamp(18px, 4vw, 34px) 64px",
  };

  const eyebrow = {
    marginBottom: 14,
    color: "#d8b763",
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
  };

  const heroTitle = {
    maxWidth: 820,
    margin: 0,
    color: "#fffaf0",
    fontSize: "clamp(2.2rem, 5vw, 4rem)",
    fontWeight: 850,
    letterSpacing: "-0.035em",
    lineHeight: 1.02,
  };

  const heroLead = {
    maxWidth: 760,
    margin: "18px 0 0",
    color: "rgba(246, 242, 232, 0.82)",
    fontSize: "clamp(1rem, 2vw, 1.15rem)",
    lineHeight: 1.72,
  };

  const infoStrip = {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 0,
    marginTop: 34,
    borderTop: "1px solid rgba(255,255,255,0.10)",
    borderBottom: "1px solid rgba(255,255,255,0.10)",
  };

  const infoItem = {
    minHeight: 94,
    padding: "18px 20px 18px 0",
  };

  const infoLabel = {
    margin: 0,
    color: "rgba(216, 183, 99, 0.88)",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  };

  const infoValue = {
    margin: "7px 0 0",
    color: "#fffaf0",
    fontSize: "0.98rem",
    fontWeight: 700,
    lineHeight: 1.5,
  };

  const section = {
    padding: "clamp(34px, 6vw, 68px) 0",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
  };

  const sectionKicker = {
    margin: "0 0 10px",
    color: "#d8b763",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
  };

  const sectionTitle = {
    margin: 0,
    color: "#fffaf0",
    fontSize: "clamp(1.65rem, 3vw, 2.35rem)",
    fontWeight: 820,
    letterSpacing: "-0.025em",
    lineHeight: 1.12,
  };

  const bodyText = {
    margin: "16px 0 0",
    color: "rgba(246, 242, 232, 0.78)",
    fontSize: "1rem",
    lineHeight: 1.76,
  };

  const bookingGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 34,
    marginTop: 30,
  };

  const bookingColumn = {
    paddingTop: 4,
  };

  const bookingHeading = {
    margin: 0,
    color: "#fffaf0",
    fontSize: "1.15rem",
    fontWeight: 800,
  };

  const price = {
    margin: "8px 0 0",
    color: "#d8b763",
    fontSize: "1.65rem",
    fontWeight: 850,
    letterSpacing: "-0.02em",
  };

  const bookingCopy = {
    minHeight: 52,
    margin: "8px 0 18px",
    color: "rgba(246, 242, 232, 0.72)",
    fontSize: 14,
    lineHeight: 1.65,
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    minHeight: 320,
    objectFit: "cover",
    display: "block",
    borderRadius: 18,
  };

  const featureList = {
    display: "grid",
    gap: 14,
    margin: "26px 0 0",
    padding: 0,
    listStyle: "none",
  };

  const featureItem = {
    display: "flex",
    gap: 12,
    alignItems: "flex-start",
    color: "rgba(246, 242, 232, 0.83)",
    lineHeight: 1.6,
  };

  const featureDot = {
    width: 7,
    height: 7,
    flex: "0 0 7px",
    marginTop: 9,
    borderRadius: "50%",
    background: "#d8b763",
  };

  const mediaFrame = {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%",
    overflow: "hidden",
    borderRadius: 18,
    background: "rgba(255,255,255,0.03)",
  };

  const iframeStyle = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    border: 0,
  };

  const addressLine = {
    margin: "5px 0 0",
    color: "rgba(246, 242, 232, 0.78)",
    lineHeight: 1.6,
  };

  const linkRow = {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginTop: 20,
  };

  const localCss = `
    .club-booking-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 50px;
      padding: 0 18px;
      border-radius: 12px;
      text-decoration: none;
      font-weight: 850;
      transition: transform 120ms ease, opacity 120ms ease, background 120ms ease;
    }

    .club-booking-link:hover {
      transform: translateY(-1px);
      opacity: 0.96;
    }

    .club-booking-primary {
      background: #d8b763;
      color: #101522;
    }

    .club-booking-secondary {
      border: 1px solid rgba(255,255,255,0.18);
      background: rgba(255,255,255,0.035);
      color: #fffaf0;
    }

    .club-month-calendar {
      display: grid;
      grid-template-columns: repeat(7, minmax(0, 1fr));
      gap: 6px;
    }

    .club-calendar-weekday {
      padding: 4px 0;
      text-align: center;
      color: rgba(246,242,232,0.72);
      font-size: 0.78rem;
      font-weight: 700;
    }

    .club-calendar-day {
      min-width: 0;
      min-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid rgba(255,255,255,0.08);
      border-radius: 9px;
      color: rgba(246,242,232,0.46);
      background: rgba(255,255,255,0.035);
      font-size: 0.9rem;
    }

    .club-calendar-day.is-session {
      background: #d8b763;
      border-color: #d8b763;
      color: #101522;
      font-weight: 900;
      box-shadow: 0 2px 12px rgba(216,183,99,0.16);
    }

    .club-map-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 42px;
      padding: 0 14px;
      border: 1px solid rgba(255,255,255,0.16);
      border-radius: 10px;
      color: #f6f2e8;
      text-decoration: none;
      font-weight: 700;
    }

    @media (max-width: 760px) {
      .club-info-strip {
        grid-template-columns: 1fr !important;
      }

      .club-info-item {
        min-height: auto !important;
        padding: 15px 0 !important;
        border-bottom: 1px solid rgba(255,255,255,0.07);
      }

      .club-info-item:last-child {
        border-bottom: 0;
      }

      .club-booking-grid {
        grid-template-columns: 1fr !important;
        gap: 28px !important;
      }
    }
  `;

  return (
    <div style={page}>
      <style>{localCss}</style>

      <Container fluid className="p-0">
        <div style={wrap}>
          <header>
            <div style={eyebrow}>Chesshood Hampshire Clubs</div>
            <h1 style={heroTitle}>{club.pageTitle}</h1>
            <p style={heroLead}>{club.intro}</p>

            <div className="club-info-strip" style={infoStrip}>
              <div className="club-info-item" style={infoItem}>
                <p style={infoLabel}>When</p>
                <p style={infoValue}>{club.schedule}</p>
              </div>
              <div className="club-info-item" style={infoItem}>
                <p style={infoLabel}>Where</p>
                <p style={infoValue}>{club.scheduleVenue}</p>
              </div>
              <div className="club-info-item" style={infoItem}>
                <p style={infoLabel}>Prices per child</p>
                <p style={infoValue}>£10 single session · 4 sessions for £32</p>
              </div>
            </div>
          </header>

          <section style={section} id="four-session-pass" aria-labelledby="four-session-pass-title">
            <div className="club-booking-grid" style={{ ...bookingGrid, marginTop: 0, alignItems: "center" }}>
              <div>
                <p style={sectionKicker}>Flexible club pass</p>
                <h2 style={sectionTitle} id="four-session-pass-title">4 sessions — £32</h2>
                <p style={{ ...bodyText, color: "#d8b763", fontWeight: 700 }}>
                  £8 per session · Save £8
                </p>
              </div>
              <div>
                <p style={{ ...bookingCopy, minHeight: 0 }}>
                  Four sessions for one child at {club.scheduleVenue}.
                  No fixed dates. One-off payment.
                </p>
                <a
                  href={club.fourSessionPassUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="club-booking-link club-booking-primary"
                >
                  Buy 4 sessions — £32
                </a>
                <p style={{ ...bookingCopy, minHeight: 0, margin: "12px 0 0" }}>
                  Enter your child's name and parent or guardian details at checkout.
                </p>
              </div>
            </div>
          </section>

          <section style={section} id="club-calendar">
            <p style={sectionKicker}>November and December 2026 · Bookings open</p>
            <h2 style={sectionTitle}>Book a single session — £10</h2>
            <p style={{ ...bodyText, maxWidth: 780 }}>
              Highlighted dates are the planned club sessions. Book one place per child
              and date for £10. Choose the same date again during secure Stripe
              checkout, enter your child's name and pay. No subscription needed.
            </p>
            <p style={{ ...bodyText, color: "#e1c581", maxWidth: 780, fontSize: "0.95rem" }}>
              November dates are subject to final venue availability confirmation.
              If any session changes, we will contact affected families.
            </p>
            <div className="club-booking-grid" style={bookingGrid}>
              <MonthBookingCalendar
                title="November 2026"
                monthIndex={10}
                sessionDays={club.novemberSessionDays}
                paymentUrl={club.novemberPaygUrl}
              />
              <MonthBookingCalendar
                title="December 2026"
                monthIndex={11}
                sessionDays={club.decemberSessionDays}
                paymentUrl={club.decemberPaygUrl}
              />
            </div>
            <p style={{ ...bodyText, marginTop: 22 }}>
              Christmas and New Year break: no club sessions on 24, 25 or
              31 December 2026, or 1 January 2027.
            </p>
          </section>
          <section style={section}>
            <p style={sectionKicker}>Online one-to-one lessons</p>
            <h2 style={sectionTitle}>Book an online chess lesson</h2>
            <p style={{ ...bodyText, maxWidth: 720 }}>
              Private online coaching for children and adults costs £30 for 60 minutes.
              Request a suitable date and time, then pay securely once your appointment is confirmed.
            </p>
            <div style={{ maxWidth: 460, marginTop: 24 }}>
              <a href="/online-chess-lessons.html#request" className="club-booking-link club-booking-primary">
                Book online coaching — £30 per hour
              </a>
            </div>
          </section>
          {clubId === "colden-common" && Date.now() < Date.parse("2026-10-30T18:00:00Z") && (
          <section style={section}>
            <p style={sectionKicker}>October booking</p>
            <h2 style={sectionTitle}>Book your October chess sessions</h2>
            <p style={{ ...bodyText, maxWidth: 700 }}>
              Book securely through Stripe for £10 per child per session.
              Choose your preferred October date at checkout and enter your
              child's name. October is Pay As You Go only, with no monthly
              pass or recurring payment.
            </p>

            <div className="club-booking-grid" style={bookingGrid}>
              <div style={bookingColumn}>
                <h3 style={bookingHeading}>October 2026 — Pay As You Go</h3>
                <div style={price}>£10</div>
                <p style={bookingCopy}>
                  One child, one session. Select your October date during
                  Stripe checkout. Book each session separately.
                </p>
                <a
                  href={club.paygUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="club-booking-link club-booking-primary"
                >
                  Book an October Session — £10
                </a>
              </div>

              <div style={bookingColumn}>
                <h3 style={bookingHeading}>October dates</h3>
                <p style={infoValue}>{club.octoberDates}</p>
                <p style={bookingCopy}>
                  {club.schedule}. All times are UK local time.
                </p>
                <p style={{ ...infoLabel, marginTop: 18 }}>
                  Club break: 13–20 October 2026
                </p>
                <p style={bookingCopy}>{club.breakNote}</p>
              </div>
            </div>

            {showSeptemberBooking && (
              <div
                style={{
                  marginTop: 30,
                  paddingTop: 24,
                  borderTop: "1px solid rgba(255,255,255,0.10)",
                  maxWidth: 700,
                }}
              >
                <h3 style={bookingHeading}>Still booking for September?</h3>
                <p style={bookingCopy}>
                  The final September session is {club.septemberSession}.
                  Single-session booking remains £10 per child. Please choose
                  this date in the September checkout.
                </p>
                <a
                  href={club.septemberPaygUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="club-booking-link club-booking-secondary"
                >
                  Book the Final September Session — £10
                </a>
              </div>
            )}
          </section>

          )}
          <section style={section}>
            <Row className="g-5 align-items-center">
              <Col xs={12} md={7}>
                <p style={sectionKicker}>The club experience</p>
                <h2 style={sectionTitle}>Serious learning in a friendly environment</h2>
                <p style={bodyText}>
                  Sessions are designed to help children improve through a
                  balanced mix of coaching, practical play and guided feedback.
                  Beginners receive clear foundations, while improving players
                  are encouraged to think more independently and make better
                  decisions over the board.
                </p>
                <p style={bodyText}>
                  Children play regularly against other juniors, discuss key
                  moments from their games and learn how to turn mistakes into
                  useful lessons. The emphasis is on steady progress, confidence
                  and enjoyment rather than pressure.
                </p>

                <ul style={featureList}>
                  {BENEFITS.map((benefit) => (
                    <li key={benefit} style={featureItem}>
                      <span aria-hidden="true" style={featureDot} />
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </Col>

              <Col xs={12} md={5}>
                <img
                  src="/chesscamp.webp"
                  alt={`Junior chess coaching at ${club.shortLabel}`}
                  style={imageStyle}
                />
              </Col>
            </Row>
          </section>

          <section style={section}>
            <Row className="g-5 align-items-start">
              <Col xs={12} md={5}>
                <p style={sectionKicker}>Coaching approach</p>
                <h2 style={sectionTitle}>Build skills that last beyond one game</h2>
                <p style={bodyText}>
                  Good chess coaching is not only about finding the best move.
                  It teaches children how to concentrate, compare choices,
                  recognise patterns and stay composed when a position becomes
                  difficult.
                </p>
                <p style={bodyText}>
                  Each session aims to give children something practical they
                  can remember and use in their next game. Over time, those
                  small improvements become stronger habits and more confident
                  decision-making.
                </p>
                <p style={{ ...bodyText, color: "rgba(216, 183, 99, 0.9)" }}>
                  Chesshood supports part of the running costs so local junior
                  chess training can remain accessible to more families across
                  Hampshire.
                </p>
              </Col>

              <Col xs={12} md={7}>
                <div style={mediaFrame}>
                  <iframe
                    title="Junior Chess Club Video"
                    src={YT_EMBED_SRC}
                    style={iframeStyle}
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
              </Col>
            </Row>
          </section>

          <section style={{ ...section, borderBottom: 0 }}>
            <Row className="g-5 align-items-start">
              <Col xs={12} md={4}>
                <p style={sectionKicker}>Location</p>
                <h2 style={sectionTitle}>{club.venueName}</h2>

                <div style={{ marginTop: 18 }}>
                  {club.venueLines.map((line) => (
                    <p key={line} style={addressLine}>
                      {line}
                    </p>
                  ))}
                </div>

                <div style={linkRow}>
                  <a
                    href={placeUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="club-map-link"
                  >
                    View map
                  </a>
                  <a
                    href={directionsUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="club-map-link"
                  >
                    Directions
                  </a>
                </div>
              </Col>

              <Col xs={12} md={8}>
                <div style={mediaFrame}>
                  <iframe
                    title={club.mapTitle}
                    src={mapEmbedUrl}
                    style={iframeStyle}
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </Col>
            </Row>
          </section>
        </div>
      </Container>
    </div>
  );
}

export default ChessClubVenuePage;
